import Vue from 'vue';
import Router from 'vue-router';
import store from '../store'; // 引入 Vuex store

Vue.use(Router);

// 解决重复点击报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: 'active',
    routes: [
        {
            path: '/',
            name: 'index',
            component: (resolve) => require(['/src/view/web/index.vue'], resolve),
            meta: { title: 'index' },
        },
        {
            path: '/doge',
            name: 'doge',
            component: (resolve) => require(['/src/view/web/doge.vue'], resolve),
            props: true,
        },
        {
            path: '/buyPage/:packageId', // 定义带有参数的路由
            name: 'buyPage',
            component: (resolve) => require(['/src/view/web/buyPage.vue'], resolve),
            props: true, // 允许将路由参数作为组件的props传递
        },
        {
            path: '/recordList', // 定义带有参数的路由
            name: 'recordList',
            component: (resolve) => require(['/src/view/web/recordList.vue'], resolve),
            props: true, // 允许将路由参数作为组件的props传递
        },
        {
            path: '/my', // 定义带有参数的路由
            name: 'my',
            component: (resolve) => require(['/src/view/web/my.vue'], resolve),
            props: true, // 允许将路由参数作为组件的props传递
        },
        {
            path: '/aboutUs', // 定义带有参数的路由
            name: 'aboutUs',
            component: (resolve) => require(['/src/view/web/aboutUs.vue'], resolve),
            props: true, // 允许将路由参数作为组件的props传递
        },
        {
            path: '/billList',
            name: 'billList',
            component: (resolve) => require(['/src/view/web/billList.vue'], resolve),
            props: (route) => ({ type: route.query.type || route.params.type }),
        },
        {
            path: '/billList:type',
            name: 'billListLegacy',
            component: (resolve) => require(['/src/view/web/billList.vue'], resolve),
            props: (route) => ({ type: route.query.type || route.params.type }),
        },
        {
            path: '/newsDetail', // 定义带有参数的路由
            name: 'newsDetail',
            component: (resolve) => require(['/src/view/web/newsDetail.vue'], resolve),
            props: (route) => ({
                id: route.query.id || route.params.id, // 映射 URL 中的 'id' 到 prop 'announcementId'
            }),
        },
        {
            path: '/myWallet', // 定义带有参数的路由
            name: 'myWallet',
            component: (resolve) => require(['/src/view/web/myWallet.vue'], resolve),
            props: true, // 允许将路由参数作为组件的props传递
        },
        {
            path: '/withdraw', // 定义带有参数的路由
            name: 'withdraw',
            component: (resolve) => require(['/src/view/web/withdraw.vue'], resolve),
            props: true, // 允许将路由参数作为组件的props传递
        },
 
        {
            path: '/withdrawAddress',
            name: 'withdrawAddress',
            component: (resolve) => require(['/src/view/web/withdrawAddress.vue'], resolve),
            props: true,
        },
        {
            path: '/friendTransfer',
            name: 'friendTransfer',
            component: (resolve) => require(['/src/view/web/friendTransfer.vue'], resolve),
            props: true,
        },
        {
            path: '/notices',
            name: 'notices',
            component: (resolve) => require(['/src/view/web/notices.vue'], resolve),
            props: true,
        },
        {
            path: '/exchangeRecords',
            name: 'exchangeRecords',
            component: (resolve) => require(['/src/view/web/exchangeRecords.vue'], resolve),
            props: true,
        },
        {
            path: '/myTeam', // 定义带有参数的路由
            name: 'myTeam',
            component: (resolve) => require(['/src/view/web/myTeam.vue'], resolve),
            props: true, // 允许将路由参数作为组件的props传递
        },
        {
            path: '/exchange', // 定义带有参数的路由
            name: 'exchange',
            component: (resolve) => require(['/src/view/web/exchange.vue'], resolve),
            props: true, // 允许将路由参数作为组件的props传递
        },
        {
            path: '/deposit', // 定义带有参数的路由
            name: 'deposit',
            component: (resolve) => require(['/src/view/web/deposit.vue'], resolve),
            props: true, // 允许将路由参数作为组件的props传递
        },
         {
            path: '/invite', // 定义带有参数的路由
            name: 'invite',
            component: (resolve) => require(['/src/view/web/invite.vue'], resolve),
            props: true, // 允许将路由参数作为组件的props传递
        },
        {
            path: '/question', // 定义带有参数的路由
            name: 'question',
            component: (resolve) => require(['/src/view/web/question.vue'], resolve),
            props: true, // 允许将路由参数作为组件的props传递
        },
         {
            path: '/setting', // 定义带有参数的路由
            name: 'setting',
            component: (resolve) => require(['/src/view/web/setting.vue'], resolve),
            props: true, // 允许将路由参数作为组件的props传递
        },
        {
            path: '/404',
            name: '404',
            component: (resolve) => require(['/src/view/404.vue'], resolve),
        },
        {
            path: '*',
            redirect: '/404',
        },
    ],
});

// 全局前置守卫：在每次路由跳转前执行
router.beforeEach(async (to, from, next) => {
    // DOGE 页面使用钱包登录体系，不使用 localStorage.token 做路由拦截；
    // 用户页后续由钱包连接 + 默认邀请码绑定逻辑处理。
    // 0. 解析邀请码 (这里解析并存入 store，无论钱包是否连接)
    // 邀请码解析最好放在更早的 main.js 或 App.vue 的 created 钩子里，确保在 store 初始化后立即执行
    // 或者确保 store.dispatch 能够访问到 URL
    // 这里简化处理，只在 mounted 里执行
    
    const inviteCode = to.query.inviteCode || to.query.invite_code || to.params.inviteCode;
    if (inviteCode) {
        store.commit('setInviteCode', String(inviteCode).toUpperCase());
        localStorage.setItem('inviteCode', String(inviteCode).toUpperCase());
    } else if (!store.getters.getInviteCode && localStorage.getItem('inviteCode')) {
        store.commit('setInviteCode', localStorage.getItem('inviteCode'));
    }

    // 1. 自动检查只恢复钱包连接状态，不主动签名/绑定；签名只在进入私有页面或用户主动操作时触发。
    if (!store.getters.isWalletConnected && !store.getters.isLoadingWallet && !store.getters.getWalletConnectionError) {
        await store.dispatch('checkWalletConnectionAction');
    }


    const dogePrivatePaths = [
        '/my', '/buyPage', '/recordList', '/myWallet', '/billList', '/exchangeRecords',
        '/myTeam', '/exchange', '/deposit', '/withdraw', '/withdrawAddress', '/friendTransfer',
        '/invite', '/setting'
    ];
    const needsDogeAuth = dogePrivatePaths.some(path => to.path === path || to.path.indexOf(path + '/') === 0);
    if (needsDogeAuth && !store.getters.isWalletConnected) {
        if (Vue.prototype.$messageDialog) {
            Vue.prototype.$messageDialog.alert('请先连接钱包', '提示', 'info');
        }
        return next('/');
    }
    // 私有页先完成钱包签名登录，再拉地址信息；地址信息没回来前不判断/不弹邀请框。
    if (store.getters.isWalletConnected && needsDogeAuth) {
        try {
            await store.dispatch('ensureDogeAuth');
        } catch (e) {
            store.commit('setDogeAuthToken', null);
            if (Vue.prototype.$messageDialog) {
                Vue.prototype.$messageDialog.alert(e.message || '请先完成钱包签名登录', '提示', 'info');
            }
            return next(false);
        }
        if (!store.getters.isUserDetailsLoaded || store.getters.getUserDetailsError) {
            await store.dispatch('fetchUserDetails');
        }
    }

    // 2. 检查是否需要弹出绑定邀请人窗口
    // 定义一个白名单，这些页面即使用户未绑定上级也可以访问
    // 您可以根据需要自定义这个列表
    const whitelist = ['/', '/aboutUs', '/notices', '/newsDetail', '/question'];

    const shouldCheckInviter = store.getters.isWalletConnected && !whitelist.includes(to.path);
    if (shouldCheckInviter && !store.getters.isUserDetailsLoaded && !store.getters.isLoadingUserDetails) {
        await store.dispatch('fetchUserDetails');
    }

    // 地址接口失败/未完成时，不把未知状态当成“未绑定”，避免误弹邀请框。
    if (shouldCheckInviter && !store.getters.isUserDetailsLoaded) {
        return next(false);
    }

    // 重新从 store 获取最新的绑定状态
    const isBound = store.getters.isInviterBound;

    if (store.getters.isWalletConnected && isBound) {
        store.commit('setShowBindInviterModal', false);
    }

    // 核心判断逻辑:
    // 如果钱包已连接，且地址接口确认没有绑定上级，并且要去的页面不在白名单里
    if (shouldCheckInviter && !isBound) {
        store.commit('setShowBindInviterModal', true); // 触发弹窗
        return next(false); // 中断本次导航
    }

    // 继续路由跳转
    next();
});
export default router;
